'use client'

import { AccountOutlineIcon } from '@/components/icons/AccountOutlineIcon'
import { AddFlightIcon } from '@/components/icons/AddFlightIcon'
import { MoonIcon } from '@/components/icons/MoonIcon'
import { SunIcon } from '@/components/icons/SunIcon'
import { HamburgerNavMenuItem } from '@/components/ui/HamburgerNavMenu'
import { useDarkMode } from '@/components/utils/DarkModeProvider'
import { cn } from '@/lib/utils'
import { usePathname } from 'next/navigation'

export function GlobalNavMenuItems() {
  const [darkmode, setDarkmode] = useDarkMode()
  const currentPath = usePathname()
  return (
    <>
      <HamburgerNavMenuItem
        onClick={() => currentPath === '/flight-search' && window.location.reload()}
        href="/flight-search"
      >
        <AddFlightIcon className="h-6 w-6" />
        <p>Work a New Flight</p>
      </HamburgerNavMenuItem>

      <button
        type="button"
        onClick={() => setDarkmode((prev) => !prev)}
        className={cn(
          'flex w-full flex-row gap-3 rounded p-3 outline-2 -outline-offset-1 outline-[#0860C4] dark:outline-[#0D4A80]',
          'hover:bg-[#ECF4FE] hover:outline dark:hover:bg-[#051E33]',
          'focus:bg-[#ECF4FE] focus:outline dark:focus:bg-[#051E33]'
        )}
      >
        {darkmode ? <SunIcon className="h-6 w-6" /> : <MoonIcon className="h-6 w-6" />}
        <p>{darkmode ? 'Light' : 'Dark'} Mode</p>
      </button>

      <HamburgerNavMenuItem href="/sign-out">
        <AccountOutlineIcon className="h-6 w-6" />
        <p>Sign Out</p>
      </HamburgerNavMenuItem>
    </>
  )
}
